export const InitialValueCliente = Object.freeze({
    IdCliente: 0,
    Nombre: "",
})